import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  hollow?: boolean;
};

export const SharedPrizePoolIcon = ({ size = 2, hollow = true }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
    >
      <g clipPath="url(#clip0_27791_114975)">
        <path
          d="M6.12128 4.97302C7.33396 4.97314 8.31736 5.95646 8.31757 7.16931C8.31757 7.99891 7.85691 8.72152 7.17792 9.09509C7.96973 9.39701 8.59009 10.0282 8.85858 10.8138C9.15944 10.3514 9.69303 10.0443 10.3 10.0443C11.2389 10.0445 12.0001 10.7802 12.0002 11.6879H0.000183105C0.000269101 10.7801 0.762238 10.0443 1.70135 10.0443C2.43443 10.0444 3.05927 10.493 3.29803 11.1215C3.49618 10.1943 4.1709 9.43545 5.06366 9.09509C4.38472 8.72151 3.92499 7.99906 3.92499 7.16931C3.92519 5.95658 4.9085 4.97302 6.12128 4.97302ZM1.8703 7.28064C2.56303 7.28064 3.12518 7.84279 3.12518 8.53552C3.12507 9.22816 2.56296 9.78943 1.8703 9.78943C1.17767 9.78939 0.616509 9.22814 0.616394 8.53552C0.616394 7.84281 1.1776 7.28068 1.8703 7.28064ZM10.4689 7.28064C11.1617 7.28064 11.7228 7.84279 11.7228 8.53552C11.7227 9.22816 11.1616 9.78943 10.4689 9.78943C9.77627 9.78943 9.21514 9.22816 9.21503 8.53552C9.21503 7.84279 9.7762 7.28064 10.4689 7.28064ZM2.81464 4.58923H1.77948V5.599H0.99823V3.80896H2.81464V4.58923ZM11.007 5.599H10.2267V4.58923H9.19061V3.80896H11.007V5.599ZM7.35956 2.25818L9.00409 1.64294L7.90936 4.34607H4.33221L3.23846 1.64294L4.81854 2.25818L6.12128 0.512085L7.35956 2.25818Z"
          fill={hollow ? 'url(#paint0_linear_27791_114975)' : 'currentColor'}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_27791_114975"
          x1="-0.700951"
          y1="17.4746"
          x2="14.2818"
          y2="15.1371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC8CD6" />
          <stop offset="0.395607" stopColor="#BE92D4" />
          <stop offset="0.594499" stopColor="#A28BD7" />
          <stop offset="1" stopColor="#98DDF4" />
        </linearGradient>
        <clipPath id="clip0_27791_114975">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
